import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { ArrowLeft, Building2, Dumbbell, Search, User } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function SubscriptionChoice() {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <div className="w-full max-w-3xl">
        <div className="text-center mb-8">
          <img src="/ergshoot-logo.png" alt="ErgShoot" className="h-12 w-auto mx-auto mb-4" />
          <h1 className="text-3xl font-bold text-foreground">Choose Your Path</h1>
          <p className="text-muted-foreground mt-2 text-lg">How would you like to use ErgShoot?</p>
        </div>

        <div className="grid gap-6 sm:grid-cols-2">
          {/* Join a Gym */}
          <Card className="border-border hover:border-primary/50 transition-all">
            <CardHeader className="text-center pb-4">
              <div className="flex justify-center mb-3">
                <div className="rounded-full bg-primary/10 p-4">
                  <Building2 className="h-8 w-8 text-primary" />
                </div>
              </div>
              <CardTitle className="text-xl">Join a Gym</CardTitle>
              <CardDescription>Train with a community at an ErgShoot affiliate gym</CardDescription>
            </CardHeader>
            <CardContent className="space-y-4">
              <ul className="space-y-2 text-sm text-muted-foreground">
                <li className="flex items-center gap-2">
                  <Search className="h-4 w-4 text-primary shrink-0" />
                  Find your local ErgShoot gym
                </li>
                <li className="flex items-center gap-2">
                  <User className="h-4 w-4 text-primary shrink-0" />
                  Join as a member — free with your gym
                </li>
              </ul>
              <Link to="/find-gym" className="block">
                <Button className="w-full" size="lg">
                  <Search className="h-4 w-4 mr-2" />
                  Find My Gym
                </Button>
              </Link>
              <p className="text-xs text-center text-muted-foreground">
                Your gym owner may need to invite you first
              </p>
            </CardContent>
          </Card>

          {/* Train Solo */}
          <Card className="border-border hover:border-primary/50 transition-all">
            <CardHeader className="text-center pb-4">
              <div className="flex justify-center mb-3">
                <div className="rounded-full bg-primary/10 p-4">
                  <Dumbbell className="h-8 w-8 text-primary" />
                </div>
              </div>
              <CardTitle className="text-xl">Train Solo</CardTitle>
              <CardDescription>
                Access ErgShoot programming as an individual athlete
              </CardDescription>
            </CardHeader>
            <CardContent className="space-y-4">
              <ul className="space-y-2 text-sm text-muted-foreground">
                <li className="flex items-center gap-2">
                  <Dumbbell className="h-4 w-4 text-primary shrink-0" />
                  Full programming library access
                </li>
                <li className="flex items-center gap-2">
                  <User className="h-4 w-4 text-primary shrink-0" />
                  Global leaderboards & progress tracking
                </li>
              </ul>
              <Link to="/signup/individual" className="block">
                <Button variant="outline" className="w-full" size="lg">
                  <Dumbbell className="h-4 w-4 mr-2" />
                  Individual Subscription — $6.75/mo
                </Button>
              </Link>
              <p className="text-xs text-center text-muted-foreground">
                Cancel anytime, no lock-in
              </p>
            </CardContent>
          </Card>
        </div>

        <div className="mt-8 text-center">
          <Link to="/" className="text-sm text-muted-foreground hover:text-foreground">
            <ArrowLeft className="h-4 w-4 inline mr-1" />
            Back to home
          </Link>
        </div>
      </div>
    </div>
  );
}
